'use client';

import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib';
import { useSidebar } from '../index';

export function SidebarToggle() {
  const { toggleSidebar, open, isExpandedView } = useSidebar();

  // Hide the toggle button in expanded view
  if (isExpandedView) {
    return null;
  }

  return (
    <button
      aria-label="Navigation menu expand toggle"
      className="bg-primary dark:bg-grey-100 dark:text-primary flex h-5 max-h-5 w-5 max-w-5 cursor-pointer items-center justify-center rounded-full p-0 text-neutral-100"
      onClick={toggleSidebar}
    >
      <ChevronRight
        className={cn(
          'h-4! w-4! translate-x-[0px] stroke-3! transition-transform duration-300 ease-in-out',
          open ? 'rotate-180' : 'translate-x-[1px]!'
        )}
      />
    </button>
  );
}
